import React, { useState } from "react";

const ConfirmResetButton = ({
  buttonText = "Reset Application",
  confirmTitle = "Are you sure you want to Reset Your Application?",
  confirmMessage = "This action will delete all the info associated with your application and reset it completely.",
  iconSrc = "/warning-circle.svg",
  onConfirm = () => {},
  onBack = () => {},
}) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      {/* Reset Button */}
      <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0 md:space-x-4 relative">
        <button
          onClick={() => setShowModal(true)}
          className="flex w-full md:w-auto bg-[#FF5050] items-center justify-center space-x-2 text-white font-medium py-2 px-4 rounded-full text-sm"
        >
          <span>{buttonText}</span>
        </button>
        <div
          onClick={() => onBack()}
          className="flex items-center space-x-2 text-sm border-2 border-white bg-white rounded-full md:text-md font-medium py-1 px-6 text-black cursor-pointer hover:bg-gray-100"
        >
          {/* Image on the left */}
          <img
            src="/bottom-back.svg" // Path to your image
            alt="Back Icon"
            className="w-4 h-4"
          />
          <span className="font-medium">Back</span>
        </div>
      </div>

      {/* Confirmation Modal */}
{showModal && (
  <div className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center bg-black bg-opacity-50 z-[9999]">
    <div className="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center relative">
      <button
        onClick={() => setShowModal(false)}
        className="absolute top-3 right-3 text-black text-xl font-bold"
      >
        &times;
      </button>

      <div className="flex justify-center items-center mb-4">
        <img src={iconSrc} alt="Warning Icon" className="h-10 w-10" />
      </div>

      <h2 className="text-lg font-medium mb-2">{confirmTitle}</h2>
      <p className="text-sm text-black mb-4">{confirmMessage}</p>

      <div className="flex justify-center space-x-4">
        <button
          onClick={() => setShowModal(false)}
          className="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
        >
          No
        </button>
        <button
          onClick={() => {
            setShowModal(false);
            onConfirm();
          }}
          className="px-6 py-2 bg-black text-white rounded-full font-medium hover:bg-gray-800"
        >
          Yes
        </button>
      </div>
    </div>
  </div>
)}

    </>
  );
};

export default ConfirmResetButton;
